/**
 * @author ling.liu
 */

export default {
  /**
 * 返回一个成功的结果
 *
 * @param {Object} result 详细数据
 * @param {String} code 成功的代码
 * @param {String} message 成功的消息
 */
  success: function (result, code, message) {
    return {
      success: true,
      data: result,
      statusCode: code || 100,
      statusDesc: message || null,
      errors: {}
    }
  },
  /**
   * 返回一个失败的结果
   *
   * @param {Object} result 详细数据
   * @param {String} code 失败的代码
   * @param {String} message 失败的消息
   */
  failure: function (result, code, message) {
    return {
      success: false,
      data: result,
      statusCode: code || null,
      statusDesc: message || null,
      errors: {}
    }
  }
};




// WEBPACK FOOTER //
// ./src/mock/common-result.js